/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CCTokenRetrieveTerminalToken = {
    properties: {
        districtId: {
            type: 'string',
            isRequired: true,
            format: 'uuid',
        },
        sessionId: {
            type: 'string',
            isRequired: true,
            minLength: 1,
        },
        recurringPayments: {
            type: 'boolean',
        },
        isSaved: {
            type: 'boolean',
        },
    },
};